"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatIntl_1 = __importDefault(require("./formatIntl"));
const unwrap_1 = __importDefault(require("./unwrap"));
/**
 * Formats an amount in a given currency
 * @param {number | undefined} amount The currency amount
 * @param {?string} currency The currency of the amount
 */
const formatCurrency = (amount, currency = 'USD') => (0, unwrap_1.default)(amount, amount => (0, formatIntl_1.default)(amount, { style: 'currency', currency }));
exports.default = formatCurrency;
